import clsx from 'clsx';
import { FormHTMLAttributes } from 'react';

export type BoxFormProps = FormHTMLAttributes<HTMLFormElement>;

export const BoxForm = ({ className, ...props }: BoxFormProps) => {
  return (
    <form
      className={clsx(
        'gap-5 bg-white flex flex-col rounded-lg overflow-auto',
        className
      )}
      {...props}
    />
  );
};
